var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManualTransmissionIcon = function SvgManualTransmissionIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    viewBox: "0 0 122.88 122.88"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.44 0A61.46 61.46 0 1 1 18 18 61.23 61.23 0 0 1 61.44 0Zm4.07 82.09a6.67 6.67 0 1 1-8.14 0V68.62H42.31v13.47a6.67 6.67 0 1 1-8.14 0V46.17a6.67 6.67 0 1 1 8.14 0v14.31h15.06V46.17a6.67 6.67 0 1 1 8.14 0v14.31h15.06V46.17a6.67 6.67 0 1 1 8.14 0V64a4.41 4.41 0 0 1 0 .52 4.07 4.07 0 0 1-4.07 4.07H65.51v13.5Zm33-57.76a52.46 52.46 0 1 0 15.38 37.11 52.29 52.29 0 0 0-15.34-37.11Z"
  })));
};
export default SvgManualTransmissionIcon;